import React from "react";
import PropTypes from "prop-types";
import Select from "../Select";
import DateInput from "../DateInput";
import style from "../../../assets/css/styles.module.scss";
import InputWrapper from "../InputWrapper";

const SelectBasedDates = ({
  value,
  id,
  onChange,
  options,
  selectOptions,
  isValid,
  errorMsg,
  className,
  firstDisabler,
  secondDisabler,
  selectName,
  firstDateName,
  secondDateName,
  label,
  afterInputText,
  minDateFirst,
  maxDateFirst,
  minDateSecond,
  maxDateSecond
}) => {
  const { operator, startDate, endDate } = value;

  const selectChanged = event => {
    const operatorValue = event.target.value;
    let newStartDate = startDate;
    let newEndDate = endDate;
    if (operatorValue === firstDisabler) {
      newStartDate = null;
      newEndDate = null;
    } else if (operatorValue !== secondDisabler) {
      newEndDate = null;
    }
    onChange({ target: { value: { operator: operatorValue, startDate: newStartDate, endDate: newEndDate } } });
  };

  const setStartDate = date => {
    if (operator !== firstDisabler) {
      onChange({ target: { value: { operator, startDate: date.target.value, endDate } } });
    }
  };

  const setEndDate = date => {
    if (operator === secondDisabler) {
      onChange({ target: { value: { operator, startDate, endDate: date.target.value } } });
    }
  };

  return (
    <InputWrapper
      id={id}
      className={`${className} ${style.stringSearchOptions}`}
      isValid={isValid}
      errorMsg={errorMsg}
      label={label}
      afterInputText={afterInputText}
    >
      <>
        <Select
          name={selectName}
          value={operator}
          onChange={selectChanged}
          selectOptions={options}
          options={selectOptions}
          id={`${id}Select`}
          className={`${style.nested}`}
        />
        <DateInput
          isValid={operator === firstDisabler || !!startDate}
          name={firstDateName}
          className={`${style.nested} ${style.dateForSelect}`}
          onChange={setStartDate}
          value={startDate}
          disabled={operator === firstDisabler}
          id={`${id}firstDate`}
          minDate={minDateFirst}
          maxDate={maxDateFirst}
        />
        <DateInput
          isValid={operator !== secondDisabler || !!endDate}
          name={secondDateName}
          className={`${style.nested} ${style.dateForSelect}`}
          disabled={operator !== secondDisabler}
          value={endDate}
          onChange={setEndDate}
          id={`${id}secondDate`}
          minDate={minDateSecond}
          maxDate={maxDateSecond}
        />
      </>
    </InputWrapper>
  );
};

SelectBasedDates.displayName = "SelectBasedDates";

SelectBasedDates.defaultProps = {
  value: { operator: "", startDate: null, endDate: null },
  id: "",
  options: [],
  onChange: () => {},
  isValid: null,
  className: "",
  errorMsg: null,
  firstDisabler: null,
  secondDisabler: null,
  selectName: "",
  firstDateName: "",
  secondDateName: "",
  label: null,
  afterInputText: null,
  selectOptions: {},
  maxDateSecond: "",
  minDateSecond: "",
  maxDateFirst: "",
  minDateFirst: ""
};

SelectBasedDates.propTypes = {
  /** All values */
  value: PropTypes.shape({
    operator: PropTypes.string,
    startDate: PropTypes.object,
    endDate: PropTypes.object
  }),
  /** id for wrapper */
  id: PropTypes.string,
  /** Change event callback */
  onChange: PropTypes.func,
  /** Options of Select */
  options: PropTypes.array,
  /** Add any html attributes to the select */
  selectOptions: PropTypes.object,
  /** SelectBasedDates Select name */
  selectName: PropTypes.string,
  /** SelectBasedDates first date name */
  firstDateName: PropTypes.string,
  /** SelectBasedDates second date name */
  secondDateName: PropTypes.string,
  /** Is SelectBasedDates valid */
  isValid: PropTypes.bool,
  /** Add className to the component */
  className: PropTypes.string,
  /** Validation error message */
  errorMsg: PropTypes.string,
  /** value for disabling first date */
  firstDisabler: PropTypes.string,
  /** value for disabling second date */
  secondDisabler: PropTypes.string,
  /** If provided, will add label before the input */
  label: PropTypes.string,
  /** If provided, will add text after the input */
  afterInputText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** minimum for date */
  minDateSecond: PropTypes.string,
  /** maximum for date */
  maxDateSecond: PropTypes.string,
  /** minimum for date */
  minDateFirst: PropTypes.string,
  /** maximum for date */
  maxDateFirst: PropTypes.string
};

export default SelectBasedDates;
